module.exports = {

  PENDING: 'pending',
  RESOLVED: 'resolved',

  // Deprecated:
  DRAFT: 'draft',
  WAITING_CUSTOMER_SERVICE: 'waiting-customer-service',
  WAITING_CUSTOMER: 'waiting-customer',
  CLOSED: 'closed',
};
